// extracted by mini-css-extract-plugin
module.exports = {"Container":"ReviewsPage_Container__1DqxD","Layout":"ReviewsPage_Layout__1vnOB"};